import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	errorOptOutTitle: {
		id: 'issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title',
		defaultMessage: "We couldn't switch to the old issue search",
		description: 'Error title when user opts out of NIN',
	},
	errorOptOutDesc: {
		id: 'issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-desc',
		defaultMessage: 'Refresh and try again.',
		description: 'Error message when user opts out of NIN',
	},
	errorOptOutTitleIssueTermRefresh: {
		id: 'issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title-issue-term-refresh',
		defaultMessage: "We couldn't switch to the old search",
		description: 'Error title when user opts out of NIN',
	},
});
export default messages;
